const DIGIT_WORDS: Record<string, string> = {
  EIGHT: "8",
  FIVE: "5",
  FOUR: "4",
  NINE: "9",
  ONE: "1",
  SEVEN: "7",
  SIX: "6",
  THREE: "3",
  TWO: "2",
  ZERO: "0",
};

function isApprovalPrefix(parts: string[]): boolean {
  return parts[0] === "APPROVE" && parts.length >= 2;
}

function normalize(value: string): string | null {
  const parts = value
    .trim()
    .replace(/[.!?]+$/u, "")
    .trim()
    .toUpperCase()
    .split(/\s+/u);
  if (!isApprovalPrefix(parts)) return null;
  const digits = parts.slice(1).map((part) => {
    if (/^\d+$/u.test(part)) return part;
    return DIGIT_WORDS[part] ?? null;
  });
  if (parts.length > 2 && parts.slice(1).some((part) => /^\d+$/u.test(part) && part.length !== 1))
    return null;
  return digits.some((part) => part === null) ? null : `APPROVE ${digits.join("")}`;
}

/** Accepts only the entire displayed approval phrase after bounded ASR normalization. */
export function matchesApprovalCommand(value: string, expected: string): boolean {
  const normalizedExpected = normalize(expected);
  return normalizedExpected !== null && normalize(value) === normalizedExpected;
}
